import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import * as globalMutationTypes from '@/store/mutation-types.js'
import icons from '@/mixins/icons.js'

export default {
  name: 'gebruikerConfirmationcode',

  mixins: [stringOperations, dateOperations, icons],

  data() {
    return {

      confirmationEmailsAndPhones: [],
      selectedEmailOrPhone: null,
      activationCodeReceived: false,
      activationCode: '',
      activationSuccess: false

    }
  },

  computed: {

  },

  mounted: function () {

    this.getKeyID()
    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: [],
      title: 'Gebruiker activatie',
      right: []
    })
    // this.$store.dispatch('getconfirmationcode', {
    //a
    // })
    // this.$store.commit(globalMutationTypes.SHOW_MESSAGE, ['De nieuwe bevestigingsmail is verzonden.', 'long'])
    // setTimeout(function() {
    //   window.location.href = window.location.href.split('/vue/')[0] + '/mijn-gegevens.html'
    // }, 3000)

  },

  methods: {

    getKeyID() {
      var urlParameters = decodeURIComponent(window.location.href.split('?')[1]).split('&')

      var params = []
      this.confirmationKey = null
      this.confirmationID = null
      this.confirmationEmailsAndPhones = []

      for (var x = 0; x < urlParameters.length; x++) {
        var urlparam = urlParameters[x]
        var split = urlparam.split('=')
        var urlKey = split[0]
        var urlValue = split[1]
        switch (urlKey) {
          case 'key':
            this.confirmationKey = urlValue;
            break;
          case 'ID':
            this.confirmationID = urlValue;
            break;
          case 'LE': // leerling email
            this.confirmationEmailsAndPhones.push({
              type: 'email',
              originalType: urlKey,
              uniqueID: urlKey + urlValue,
              value: urlValue
            })
            break;
          case 'LG': // leerling gsm
            this.confirmationEmailsAndPhones.push({
              type: 'phone',
              originalType: urlKey,
              uniqueID: urlKey + urlValue,
              value: urlValue
            })
            break;

        }
      }

      this.confirmationEmailsAndPhones = _.sortBy(this.confirmationEmailsAndPhones, ['type'])


    },
    emailOrPhoneSelected(email, index) {
      this._selectEnigeRecord(this.confirmationEmailsAndPhones, email, 'uniqueID')
      this.selectedEmailOrPhone = email
    },

    askActivationCode() {
      console.log('askActivationCode')
      this.$store.dispatch('getConfirmationCode', {
        dezeDit: this,
        succesCallback: this.getConfirmationCodeSuccess
      })
    },
    submitActivationCode() {
      console.log('submitActivationCode')
      this.$store.dispatch('createConfirmation', {
        dezeDit: this
        /*,
                succesCallback: this.getconfirtmationrecipientsSuccess*/
      })
    },


  }
}
